import * as Vue from "vue";
import * as mutations from "../../mutation-types"

export const processActivity = (store, item) => {
    if (item.reference) {
        switch (item.reference_type) {
            case 'project':
                store.dispatch('processProject', item.reference)
                break
            case 'proposal':
                store.dispatch('processProposal', item.reference)
                break
            case 'change-order':
                store.dispatch('processChangeOrder', item.reference)
                break
            case 'contact':
                store.dispatch('processContact', item.reference)
                break
            case 'note':
                store.dispatch('processNote', item.reference)
                break
            case 'task':
                store.dispatch('processTask', item.reference)
                break
        }
        delete item.reference
    }

    if (item.actor) {
        switch (item.actor_type) {
            case 'user':
                store.dispatch('processUser', item.actor)
                break;
            case 'contact':
                store.dispatch('processContact', item.contact)
                break;
        }
        delete item.actory
    }

    store.commit(mutations.ADD_OR_UPDATE_ACTIVITY, item)
}

export const fetchActivities = (store, params) => {
    return axios.get(`/api/activities`, { params })
        .then(res => {
            _.each(res.data.data, item => processActivity(store, item))
            return res
        })
}

export const removeActivity = (store, item) => {
    return axios.delete(`/api/activities/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_ACTIVITY, item)
            return res
        })
}